import React, {useState} from 'react';
import Tooltip from 'src/components/tooltip';
import Button from 'src/components/Button';
import {copy} from 'shared/utils';
import styles from './copy-button.module.scss';

interface Props {
  copyText: string;
  position?: string;
  children?: React.ReactNode;
  size?: string;
  onClick?: () => void;
}

function CopyButton({copyText, children, onClick, ...buttonProps}: Props) {
  const [showTooltip, setShowTooltip] = useState(false);

  const performCopy = () => {
    copy(copyText);
    setShowTooltip(true);
    onClick?.();
    setTimeout(() => {
      setShowTooltip(false);
    }, 500);
  };

  return (
    <Tooltip open={showTooltip} title="Copied!">
      <span className={styles.container}>
        <Button {...buttonProps} onClick={performCopy}>
          {children || 'Copy'}
        </Button>
      </span>
    </Tooltip>
  );
}

export default CopyButton;
